import * as THREE from 'three';
// ============================
// Material
// ============================
export const goldMaterial = new THREE.MeshStandardMaterial({
    color: 0xffd700,
    metalness: 0.1,
    roughness: 0.01,
});
// ============================
// Parametrische ∞-Kurve
// ============================
export class InfinityCurve extends THREE.Curve {
    constructor(scale = 18, z = 0) {
        super();
        this.scale = scale;
        this.z = z;
    }
    getPoint(t, optionalTarget = new THREE.Vector3()) {
        const a = this.scale;
        const angle = t * Math.PI * 2;
        const d = 1 + Math.sin(angle) ** 2;
        optionalTarget.set(a * Math.cos(angle) / d, a * Math.sin(angle) * Math.cos(angle) / d, this.z);
        return optionalTarget;
    }
}
// ============================
// Profil erstellen
// ============================
export function createProfile(width = 2.4, height = 1.6) {
    const shape = new THREE.Shape();
    shape.moveTo(-width / 2, 0);
    shape.quadraticCurveTo(-width / 2, height, 0, height);
    shape.quadraticCurveTo(width / 2, height, width / 2, 0);
    shape.lineTo(-width / 2, 0);
    return shape;
}
// ============================
// Extrusion entlang Curve
// ============================
export function buildPendant(scale = 18, heightOffset = 0.6, profileWidth = 2.4, profileHeight = 1.6) {
    const profile = createProfile(profileWidth, profileHeight);
    // Obere Bahn
    const curveTop = new InfinityCurve(scale, heightOffset / 2);
    const topMesh = new THREE.Mesh(new THREE.ExtrudeGeometry(profile, { steps: 500, bevelEnabled: false, extrudePath: curveTop }), goldMaterial);
    // Untere Bahn
    const curveBottom = new InfinityCurve(scale, -heightOffset / 2);
    const bottomMesh = new THREE.Mesh(new THREE.ExtrudeGeometry(profile, { steps: 500, bevelEnabled: false, extrudePath: curveBottom }), goldMaterial);
    // Mesh zusammenfassen
    const group = new THREE.Group();
    group.add(topMesh);
    group.add(bottomMesh);
    return group;
}
